import styled from "styled-components";
import CommonButton from "../../../components/common/CommonButton";
import { useState } from "react";
import GanttChart from "./simulatorAnalytics/GanttChart";
import FontAwesomeIcon from "../../../components/common/FontAwesomeIcon";
import { useEffect } from "react";
import ChartResultsModal from "./simulatorManagement/ResultsChartModal";
import useFetch from "../../../hooks/useFetch";
import { getSimulators } from "./api/simulator";
import MainSimulatorAnalytics from "./simulatorAnalytics/MainSimulatorAnalytics";

const SimulatorAnalytics = () => {

    const [selectedSimulator, setSelectedSimulator] = useState(null)
    const [selectedRun, setSelectedRun] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    const {
        data: fetchedSimulators,
        loading: loadingSimulators,
        error: errorSimulators
    } = useFetch({
        asyncFn: getSimulators
    })

    useEffect(() => {
        if (fetchedSimulators) {
            setSelectedSimulator(fetchedSimulators?.[0])
        }
    }, [fetchedSimulators])

    if (loadingSimulators) {
        return (
            <div>
                <h2>Cargando...</h2>
            </div>
        )
    }

    if (errorSimulators) {
        return (
            <div>
                <h2>Error al cargar los simuladores</h2>
            </div>
        )
    }

    return (
        <Container>
            <Aside>
                <h1>SIMULADOR:</h1>
                <section>
                    {
                        fetchedSimulators?.map((simulator) => {

                            console.info("simulator", simulator)

                            return (
                                <span>
                                    <SimulatorButton
                                        selected={selectedSimulator?._id === simulator?._id}
                                        onClick={() => {
                                            setSelectedSimulator(simulator)
                                        }}
                                        key={simulator?._id}
                                    >
                                        {simulator?.name}
                                    </SimulatorButton>
                                    {
                                        selectedSimulator?._id === simulator?._id && (
                                            <SimulatorInfo>
                                                {
                                                    selectedSimulator?.run_codes?.map((run) => {
                                                        return (
                                                            <RunButton 
                                                            selected={selectedRun?.run_code === run?.run_code}
                                                            onClick={() => {
                                                                setSelectedRun(run)
                                                            }}>
                                                                <p>Run: {run?.run_code}</p>
                                                            </RunButton>
                                                        )
                                                    })
                                                }
                                            </SimulatorInfo>
                                        )
                                    }

                                </span>
                            )
                        })
                    }
                </section>
            </Aside>
            <MainSimulatorAnalytics
                selectedSimulator={selectedSimulator}
                selectedRun={selectedRun}
            />
        </Container>
    )
}

export default SimulatorAnalytics;

const Container = styled.div`
    width: 100%;
    min-height: 80vh;
    height: fit-content;
    display: flex;
    background-color: #fff;
    margin-top: 2rem;
    box-shadow: 0px 8px 24px -4px #18274B14, 0px 6px 12px -6px #18274B1F;
    border-radius: 30px;
    margin-bottom: 4rem;
`

const Aside = styled.aside`
    width: 265px;
    height: 70vh;
    background-color: #b31d15;
    border-radius: 20px 0 0 20px;
    padding-top: 4rem;
    padding-left: 2rem;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    justify-content: start;
    align-items: start;
    overflow-y: auto;

    h1 {
        font-size: 16px;
        font-weight: 600;
    }

    section {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        overflow-y: auto;
    }
`

const SimulatorButton = styled.button`
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    padding: 12px 24px 12px 16px;
    border: ${({ selected }) => selected ? '1px solid #fff' : 'none'};
    background-color: transparent;
    cursor: pointer;
    border-radius: 100px;
    max-width: 250px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`

const SimulatorInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    margin-left: 24px;

    label {
        font-size: 13px;
        font-weight: 400;
    }

    button {
        cursor: pointer;
    }
`

const RunButton = styled.button`
    width: 100%;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    padding: 12px 24px 12px 16px;
    border: ${({ selected }) => selected ? '1px solid #fff' : 'none'};
    background-color: transparent;
    cursor: pointer;
    border-radius: 100px;
    max-width: 250px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    p {
        width: fit-content;
    }
`